import { render, staticRenderFns } from "./EditMultiple.vue?vue&type=template&id=4ed0accc"
import script from "./EditMultiple.vue?vue&type=script&lang=js"
export * from "./EditMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports